import { SWReactIcons } from "@similarweb/icons";
import classNames from "classnames";
import { dynamicFilterFilter } from "app/filters/dynamicFilter";
import { MarkerInnerWrapper } from "../styledComponents";

export const EngagementWidgetsLegendCompareTemplate = (props) => {
    const { legendContainerClass, toggleSeries, legendItems, colors, getIcon } = props;

    return (
        <div
            className={classNames(
                "legend",
                "legend-data",
                "compare",
                `legend-compare-${legendItems?.length}`,
                legendContainerClass,
            )}
        >
            {legendItems?.map((item, index) => {
                const iconItem = getIcon(item);
                return (
                    <div
                        className={classNames(
                            "legend-item",
                            { "legend-item--off": !!item.hidden },
                            { "legend-item--disabled": item.alwaysDisabled },
                        )}
                        onClick={() => toggleSeries(item, !!item.hidden)}
                        key={index}
                    >
                        {item.showLegendData ? (
                            <div className="legend-item-data">
                                {item.isWinner ? (
                                    <SWReactIcons
                                        iconName="winner"
                                        size="xs"
                                        className="mmx-winner"
                                    />
                                ) : null}
                                {dynamicFilterFilter()(item.data, item.format)}
                            </div>
                        ) : null}
                        <div className="site-image-and-name">
                            <span>
                                {iconItem ? (
                                    <img
                                        className={classNames("item-icon", {
                                            "website-small-icon": item.smallIcon,
                                        })}
                                        id={item.id}
                                        crossOrigin="anonymous"
                                        src={iconItem}
                                    />
                                ) : null}
                                <MarkerInnerWrapper
                                    className="item-marker--flat"
                                    color={item.color || item.Color || colors[index]}
                                />
                                <span
                                    className="item-name"
                                    title={item.name || item.Title}
                                >
                                    {item.name || item.Title}
                                </span>
                            </span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
